// material-ui
import { withStyles } from "@material-ui/styles";
import ImgShadow from "components/ImgShadow";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class Image extends Component {
  static propTypes = {
    classes: PropTypes.object,
    alt: PropTypes.string,
    src: PropTypes.string,
    title: PropTypes.string,
  };

  render() {
    return <ImgShadow {...this.props} />;
  }
}

export default withStyles(styles)(Image);
